// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import cx from 'classnames';
import IntlTelInput from '../../IntlTelInput/IntlTelInput';
import ReactCSSTransitionGroup from '../../ReactCSSTransitionGroupCompat/ReactCSSTransitionGroupCompat';
// Components
import CloudflareCaptcha from '../../CloudflareCaptcha/CloudflareCaptcha';
import OMTooltip from '../../OMComponents/OMTooltip/OMTooltip';
import appendLocale from '../../../helpers/appendLocale';
// Helper
import { PREFERRED_COUNTRIES } from '../../../constants';
import CAPTCHA_ACTIONS from '../../../helpers/captchaConstants';
// Styles
import * as styles from '../PhoneVerificationFormMyAccount.scss';
import icon from '../../../../static/icons/help-button.svg';

const lockIndent = (isMobile, locale) => {
  if (locale === 'ru') {
    return 30;
  }
  return (isMobile ? 15 : 10);
};

export default class PhoneNumberSection extends Component {
  state = {
    showTooltip: false
  };

  tooltipHandler = () => {
    this.setState({ showTooltip: !this.state.showTooltip });
  };

  handleSelectFlag = (value, flag) =>
    this.props.onPhoneChange(null, value || this.props.initialPhoneValue, flag);

  renderSubmitButton = () => !this.props.phoneIsVerified && (
    <div key="submitButton" className={styles.submitButton}>
      <CloudflareCaptcha
        action={CAPTCHA_ACTIONS.SEND_VERIFICATION_SMS}
        cdata={this.props.phoneForCaptcha}
        fetchToken={this.props.fetchReCaptchaToken}
        doReset={this.props.doResetCaptcha}
      />
      <div className={styles.tooltipButtonWrapper}>
        <button type="submit" form="verifyPhoneForm">
          {this.props.translate('verifyPhone')}
        </button>

        <div className={styles.tooltipButton}>
          <img
            src={icon}
            alt="help-icon"
            tabIndex={0}
            onClick={this.tooltipHandler}
            onBlur={() => this.setState({ showTooltip: false })}
          />
          { this.state.showTooltip ?
            <OMTooltip
              msg={this.props.tooltipMsg}
              locale={this.props.locale}
              className="phoneVerificationTooltip"
              onClose={this.tooltipHandler}
            /> : null }
        </div>
      </div>

      {(this.props.showErrorMessage) ? (
        <div className={styles.invalidMessage}>
          {this.props.errorMessage}
          {this.props.phoneNumberAlreadyTaken && (
            <Link to={appendLocale(this.props.locale, '/contact')}>
              &nbsp;
              {this.props.translate('contactUs')}
            </Link>
          )}
        </div>
      ) : null}
    </div>
  );

  renderNotReceiveSmsMessage = () => !this.props.phoneIsVerified && (
    <div key="notReceiveMessage" className={styles.notReceiveMessage}>
      {this.props.translate('notReceiveSms')}
        <button form="verifyPhoneForm" className={styles.sendAgain}>
          &nbsp;{this.props.translate('sendAgain')}
        </button>
    </div>
  );

  renderVerifiedLabel = () => this.props.phoneIsVerified && (
    <div className={styles.verified}>
      <span className="icon icon-check" />&nbsp;
      {this.props.translate('verified')}
    </div>
  );

  render() {
    const { phoneIsVerified, initialPhoneValue, isMobile, isRtl } = this.props;

    return (
      <div className={cx(styles.phoneSection, { [styles.verifiedNumber]: phoneIsVerified })}>
        <div className={styles.phoneInputWrapper}>
          <IntlTelInput
            autoPlaceholder={false}
            containerClassName={cx('intl-tel-input', styles.countrySelect)}
            inputClassName="form-control phone-input"
            fieldName="phone"
            value={this.props.initialPhoneValue}
            preferredCountries={PREFERRED_COUNTRIES}
            onPhoneNumberChange={this.props.onPhoneChange}
            onSelectFlag={this.handleSelectFlag}
            useMobileFullscreenDropdown={false}
            disabled={phoneIsVerified}
            validate={this.props.validatePhoneNumber}
            nationalMode={false}
            separateDialCode
          />
          { phoneIsVerified && initialPhoneValue && (
            <i className={cx('icon-lock', styles.lockIcon)} />
          ) }
          {this.renderVerifiedLabel()}
        </div>

        <ReactCSSTransitionGroup
          transitionName="code-section"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={400}
        >
          {(this.props.phoneNumberSent)
            ? this.renderNotReceiveSmsMessage()
            : this.renderSubmitButton()}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

PhoneNumberSection.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string,
  onChange: PropTypes.func,
  validatePhoneNumber: PropTypes.func,
  sendPhoneNumber: PropTypes.func,
  fetchReCaptchaToken: PropTypes.func,
  phoneForCaptcha: PropTypes.string,
  phoneNumberIsInvalid: PropTypes.bool,
  phoneNumberSent: PropTypes.bool,
  phoneNumberAlreadyTaken: PropTypes.bool,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  showErrorMessage: PropTypes.bool,
  doResetCaptcha: PropTypes.bool,
  errorMessage: PropTypes.string,
  tooltipMsg: PropTypes.string,
  initialPhoneValue: PropTypes.string,
  phoneIsVerified: PropTypes.bool,
  onPhoneChange: PropTypes.func
};
